/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { RoleUtils } from 'app/core/auth/roles.utils';

// if u want to add new sidebar data add it down here in subNavigation. then you need to add the id inside the file navigation-type-{userType}.data.ts

// let me explain briefly. below is where they list out all available routes and it can be reused. so down here is just a constant
// to properly display the navigation you need to put it inside the file of navigation-type-{userType}.data.ts

export const subNavigation: FuseNavigationItem[] = [
    {
        id: 'superdashboards',
        type: 'group',
        children: [
            {
                id: 'superdashboards.engagement',
                title: 'User Engagement',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/project',
            },
            {
                id: 'superdashboards.wellmaster',
                title: 'WellMaster',
                type: 'basic',
                icon: 'heroicons_outline:home-modern',
                link: '/wellmaster',
            },
            {
                id: 'superdashboards.analytics',
                title: 'Analytics',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/dashboards/analytics',
            },
            {
                id: 'superdashboards.finance',
                title: 'Finance',
                type: 'basic',
                icon: 'heroicons_outline:arrow-trending-up',
                link: '/dashboards/finance',
            },
            {
                id: 'superdashboards.panel',
                title: 'Panel',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/dashboards/panel',
            },
        ],
    },
    {
        id: 'settings',
        type: 'group',
        children: [
            {
                id: 'settings.password',
                title: 'Password',
                type: 'basic',
                icon: 'heroicons_outline:lock-closed',
                link: '/settings/password',
                disabled: true,
                badge: {
                    title: 'Coming Soon!',
                    classes: 'px-2 bg-yellow-300 text-black rounded',
                },
            },
            {
                id: 'settings.security',
                title: 'Security',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/settings/security',
                disabled: true,
                badge: {
                    title: 'Coming Soon!',
                    classes: 'px-2 bg-yellow-300 text-black rounded',
                },
            },
            {
                id: 'products.notifications',
                title: 'Notifications',
                type: 'basic',
                icon: 'heroicons_outline:bell-alert',
                link: '/settings/notifications',
                disabled: true,
                badge: {
                    title: 'Coming Soon!',
                    classes: 'px-2 bg-yellow-300 text-black rounded',
                },
            },
        ],
    },
    {
        id: 'home',
        title: 'Home',
        type: 'spacer',
        children: [
            {
                id: 'home.main',
                title: 'Home',
                type: 'basic',
                link: '/home',
            },
        ],
    },
    {
        id: 'admindashboards',
        type: 'group',
        children: [
            {
                id: 'admindashboards.wim',
                title: 'Well Integrity Management',
                type: 'collapsable',
                icon: 'heroicons_outline:squares-2x2',
                children: [
                    {
                        id: 'admindashboards.wim.overall',
                        title: 'Overall Overview',
                        type: 'basic',
                        icon: 'custom:overall-overview',
                        link: '/wim/well-integrity-management/overall-overview',
                    },
                    {
                        id: 'admindashboards.wim.wh',
                        title: 'Well Healthiness',
                        type: 'basic',
                        icon: 'custom:well-healthiness-status-2',
                        link: '/wim/well-healthiness',
                    },
                    {
                        id: 'admindashboards.wim.pm',
                        title: 'Preventive Maintenance',
                        type: 'basic',
                        icon: 'custom:preventive-maintenance-2',
                        link: '/wim/well-integrity-planning/pm-dashboard',
                    },
                    {
                        id: 'admindashboards.wim.cm',
                        title: 'Corrective Maintenance',
                        type: 'basic',
                        icon: 'custom:corrective-maintenance-2',
                        link: '/wim/cm-dashboard',
                    },
                    {
                        id: 'admindashboards.wim.moc',
                        title: 'MOC',
                        type: 'basic',
                        icon: 'custom:management-of-change',
                        link: '/wim/moc-dashboard',
                    },
                    {
                        id: 'admindashboards.wim.apr',
                        title: 'Annulus Pressure Reading',
                        type: 'basic',
                        icon: 'mat_outline:compress',
                        link: '/wim/apr-dashboard',
                    },
                ],
            },
            {
                id: 'admindashboards.wbsdiagram',
                title: 'WBS Diagram',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/well-schematic-diagram-dashboard',
            },
        ],
    },
    {
        id: 'userdashboards',
        type: 'group',
        children: [
            {
                id: 'userdashboards.project',
                title: 'Project',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/project',
            },
            {
                id: 'userdashboards.analytics',
                title: 'Analytics',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/dashboards/analytics',
            },
            {
                id: 'userdashboards.panel',
                title: 'Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/dashboards/panel',
            },
        ],
    },
    {
        id: 'datamanagement',
        type: 'group',
        children: [
            {
                id: 'datamanagement.wellheaderinfo',
                title: 'Well Header Information',
                type: 'collapsable',
                icon: 'mat_outline:info',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
                children: [
                    {
                        id: 'datamanagement.wellheaderinfo.assets',
                        title: 'Asset',
                        type: 'basic',
                        icon: 'custom:assets',
                        link: '/data-management/well-header-info/assets',
                    },
                    {
                        id: 'datamanagement.wellheaderinfo.well',
                        title: 'Well',
                        type: 'basic',
                        icon: 'custom:well-2',
                        link: '/data-management/well-header-info/wells',
                    },
                ],
            },
            {
                id: 'datamanagement.wellproductioncategory',
                title: 'Well Production Status',
                type: 'basic',
                icon: 'custom:well-production-status',
                link: '/data-management/well-prod-status',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.equipmentRegistration',
                title: 'Equipment Registration',
                type: 'basic',
                icon: 'custom:equipment-registration-2',
                link: '/data-management/eReg',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.wellIntegrityPlanning',
                title: 'Well Integrity Activity Planning',
                type: 'basic',
                icon: 'custom:well-integrity-activity-planning-2',
                link: '/data-management/well-integrity-planning',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.dailyActivityTracker',
                title: 'Daily Activity Tracker',
                type: 'basic',
                icon: 'custom:daily-activity-tracker-2',
                link: '/data-management/daily-activity-tracker',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.cdft',
                title: 'CDFT',
                type: 'basic',
                icon: 'custom:cdft-2',
                link: '/data-management/cdft',
            },
            {
                id: 'datamanagement.apRecord',
                title: 'Annulus Pressure Record',
                type: 'basic',
                icon: 'custom:annulus-pressure-record',
                link: '/data-management/annulus-pressure-record',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.wellHealthiness',
                title: 'Well Healthiness Status',
                type: 'basic',
                icon: 'custom:well-healthiness-status-2',
                link: '/data-management/well-healthiness',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.cm',
                title: 'Corrective Maintenance',
                type: 'basic',
                icon: 'custom:corrective-maintenance-2',
                link: '/data-management/corrective-maintenance',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.moc',
                title: 'Management of Change',
                type: 'basic',
                icon: 'custom:management-of-change',
                link: '/data-management/management-of-change',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            {
                id: 'datamanagement.wpb',
                title: 'Work Planning Budget',
                type: 'basic',
                icon: 'custom:work-planning-budget-2',
                link: '/data-management/work-planning-budget',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
            // {
            //   id: 'datamanagement.auditTrail',
            //   title: 'Automated Audit Trail',
            //   type: 'basic',
            //   icon: 'custom:automated_audit_trails',
            //   link: '/data-management/automated-audit-trails',
            // },
            {
                id: 'datamanagement.wbs',
                title: 'Well Barrier Status',
                type: 'basic',
                icon: 'custom:well-barrier-configuration-2',
                link: '/data-management/well-barrier-status',
                hidden: () => {
                    const hideRoles = ['Offshore Personnel'];

                    return RoleUtils.currentRoles.some((role) =>
                        hideRoles.includes(role),
                    );
                },
            },
        ],
    },
    {
        id: 'workoverreportsubmssion',
        type: 'group',
        children: [
            {
                id: 'workoverreportsubmission.wellIntegrity',
                title: 'Well Integrity',
                type: 'basic',
                icon: 'heroicons_outline:inbox-stack',
                link: '/configurations/metadata',
                badge: {
                    title: 'In Progress!',
                    classes: 'px-2 bg-teal-400 text-black rounded',
                },
            },
            {
                id: 'datamanagement.auditTrail',
                title: 'Automate Audit Trail',
                type: 'basic',
                icon: 'heroicons_outline:inbox-stack',
                link: '/data-management/wim/audit-trail',
                badge: {
                    title: 'In Progress!',
                    classes: 'px-2 bg-teal-400 text-black rounded',
                },
            },
        ],
    },
    {
        id: 'configurations',
        type: 'group',
        children: [
            {
                id: 'configurations.wellSchematicDiagram',
                title: 'Well Barrier Configuration',
                type: 'basic',
                icon: 'custom:well-barrier-configuration-2',
                link: '/configurations/well-schematic-diagram',
            },
            {
                id: 'configurations.metadata',
                title: 'Option Type',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/configurations/option-type',
            },
            {
                id: 'configurations.kpiConfiguration',
                title: 'KPI Configuration',
                type: 'basic',
                icon: 'heroicons_outline:key',
                link: '/configurations/kpi-configuration',
            },
            {
                id: 'configurations.user.management',
                title: 'User Management',
                type: 'collapsable',
                icon: 'mat_outline:contact_mail',
                children: [
                    {
                        id: 'configurations.users',
                        title: 'Users',
                        type: 'basic',
                        icon: 'mat_outline:supervisor_account',
                        link: '/configurations/user-management/users',
                    },
                    {
                        id: 'configurations.user.role',
                        title: 'Roles & Permissions',
                        type: 'basic',
                        icon: 'mat_outline:admin_panel_settings',
                        link: '/configurations/user-management/roles-permissions',
                    },
                ],
            },
        ],
    },
    {
        id: 'space-route',
        type: 'group',
        children: [
            {
                id: 'space-route.profile',
                title: 'Profile',
                type: 'basic',
                link: '/pages/profile',
                disabled: true,
                badge: {
                    title: 'Coming Soon!',
                    classes: 'px-2 bg-yellow-300 text-black rounded',
                },
            },
            {
                id: 'space-route.settings',
                title: 'Settings',
                type: 'basic',
                link: '/pages/settings',
            },
        ],
    },
    {
        id: 'unknown',
        type: 'group',
        children: [
            {
                id: 'unknown.404',
                title: '404',
                type: 'basic',
                icon: 'heroicons_outline:face-frown',
                link: '/dashboards/panel',
            },
        ],
    },
];

export const unknownNavigation: FuseNavigationItem[] = [
    {
        id: 'unknown',
        title: 'ERROR',
        type: 'group',
        icon: 'heroicons_outline:no-symbol',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
